module.exports = __webpack_public_path__ + "static/media/right-chevron.9bd8af57.svg";